<script>
export default {
  props: {
    hasPercentPlan: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    title() {
      return this.hasPercentPlan
        ? 'Talkizy & classes virtuelles : vos formations gagnent une nouvelle dimension'
        : 'Talkizy & classes virtuelles : vos formations gagnent une nouvelle dimension';
    },
    description() {
      return this.hasPercentPlan

        ? '🎥 Classes virtuelles directement dans Teachizy\n'
        + 'Notre outil de visioconférence Talkizy s\'intègre désormais à votre espace. Planifiez une classe virtuelle, invitez les apprenants d\'une ou plusieurs formations, et animez votre session toujours en lien avec Teachizy. Cette fonctionnalité est en bêta : vos retours nous aident à l\'affiner.\n\n'
        + '📅 Un calendrier pour tout piloter\n'
        + 'Échéances de formation, sessions live, dates clés : tout s\'affiche dans une vue calendrier claire. Selon votre configuration, vos apprenants peuvent eux aussi y accéder pour ne plus rien manquer.\n'
        : '🎥 Classes virtuelles directement dans Teachizy\n'
        + 'Notre outil de visioconférence Talkizy s\'intègre désormais à votre espace. Planifiez une classe virtuelle, invitez les apprenants d\'une ou plusieurs formations, et animez votre session toujours en lien avec Teachizy. Cette fonctionnalité est en bêta : vos retours nous aident à l\'affiner.\n\n'
        + '📅 Un calendrier pour tout piloter\n'
        + 'Échéances de formation, sessions live, dates clés : tout s\'affiche dans une vue calendrier claire. Selon votre configuration, vos apprenants peuvent eux aussi y accéder pour ne plus rien manquer.\n';
    },
    ctaText() {
      return this.hasPercentPlan
        ? 'Tester les classes virtuelles'
        : 'Tester les classes virtuelles';
    },
    ctaLink() {
      return this.hasPercentPlan
        ? { name: 'classe_virtuelle' }
        : { name: 'classe_virtuelle' };
    },
  },
  methods: {
    handleSeeMore() {
      this.$router.push(this.ctaLink);
      this.$emit('close');
    },
  },
};
</script>

<template>
    <AppCardModal
        tag="div"
    >
    <template #title>
      {{ title }}
    </template>
    <template #body>
      <p style="white-space: pre-line;">
        {{ description }}
      </p>
    </template>
    <template #foot>
      <b-button
        native-type="button"
        @click="$emit('close')"
      >
        Plus tard
      </b-button>
      <b-button
        type="is-primary is-custom"
        native-type="button"
        @click="handleSeeMore"
      >
        {{ ctaText }}
      </b-button>
    </template>
  </AppCardModal>
</template>
